/** @format */

"use client";
import React from "react";
import { SignUpBtn } from "../../components/allComponents/AllComponents";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SignUpBtnParent = () => {
	const navigate = useNavigate();
	const { t } = useTranslation("common");

	const redirectToSignUpPage = () => {
		navigate(`/circle/sign-up`);
	};

	const redirectToSignInPage = () => {
		navigate(`/circle/sign-in`);
	};

	return (
		<div className="flex items-center gap-1 md:gap-2">
			<SignUpBtn
				borderRadius="1.75rem"
				className="bg-white bg-slate-900 text-black text-white border-neutral-200 border-slate-800"
				handleRedirect={redirectToSignUpPage}>
				{t("buttons.signup")}
			</SignUpBtn>

			<SignUpBtn
				borderRadius="1.75rem"
				className="bg-white bg-slate-900 text-black text-white border-neutral-200 border-slate-800"
				handleRedirect={redirectToSignInPage}>
				{t("buttons.signin")}
			</SignUpBtn>
		</div>
	);
};

export default SignUpBtnParent;
